/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { PersonUserDataViewModel } from "../types/PersonUserDataViewModel.ts";
import { eUserRoleSchema } from "./eUserRoleSchema.ts";

export const personUserDataViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID do usuário.")),
  firstName: z.string().describe("Primeiro nome do usuário.").nullish(),
  lastName: z.string().describe("Sobrenome do usuário.").nullish(),
  email: z.string().describe("Endereço de e-mail do usuário.").nullish(),
  userName: z
    .string()
    .describe("Nome de usuário utilizado para autenticação.")
    .nullish(),
  phone: z.string().describe("Número de telefone fixo do usuário.").nullish(),
  celPhone: z.string().describe("Número de celular do usuário.").nullish(),
  photo: z.string().describe("URL da foto de perfil do usuário.").nullish(),
  roleId: z.optional(
    z
      .lazy(() => eUserRoleSchema)
      .describe(
        "1 = Master | 2 = Administrator | 3 = Polo | 4 = Basic | 5 = Relationship | 6 = Planning | 7 = Secretary | 8 = Communication | 9 = Financial | 10 = Visitor | 11 = API | 12 = StudentCare | 13 = Valoriza | 14 = Leads | 15 = Faculty | 16 = Orientation | 17 = Exams | 18 = BusinessCore | 19 = Contracts | 20 = HumanResources | 21 = Audiovisual | 22 = ScholarshipTeam | 23 = Translation | 24 = Transmission | 25 = RelationshipTR | 26 = International | ",
      ),
  ),
  roleName: z
    .string()
    .describe("Nome legível do perfil de acesso do usuário.")
    .nullish(),
  active: z.optional(z.boolean().describe("Indica se o usuário está ativo.")),
  language: z
    .string()
    .describe("Idioma de interface do usuário (ex: pt-BR, en-US).")
    .nullish(),
  comunicationLanguage: z
    .string()
    .describe(
      "Idioma preferencial de comunicação do usuário (ex: pt-BR, en-US).",
    )
    .nullish(),
  changePassword: z.optional(
    z
      .boolean()
      .describe("Indica se o usuário deve alterar a senha no próximo acesso."),
  ),
  lastLoginDate: z
    .string()
    .datetime()
    .describe("Data e hora do último login do usuário. Opcional.")
    .nullish(),
  creationDate: z
    .string()
    .datetime()
    .describe("Data de criação do usuário. Opcional.")
    .nullish(),
}) as unknown as ToZod<PersonUserDataViewModel>;
